import { message } from "antd";
import enrollmentServices from "../Services/enrollmentServices";
import PaymentService from "../Services/PaymentService";
import moment from "moment";
import { Base64 } from "js-base64";
import { Buffer } from "buffer";
import sha256 from "crypto-js/sha256";
import AppointmentService from "../Services/AppointmentService";
import axios from "axios";
window.Buffer = Buffer;

export const patientPayment = async (data, appointmentObj) => {
  try {
    const result = await enrollmentServices.Invite(data);

    if (!result.data) {
      message.error("Registration Failed");
      return;
    }

    const convertUTCDate = (date, format = "MM/DD/YYYY") => {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes()
      );
      return moment(new Date(date)).utc().format(format);
    };

    if (result.data.code === "FAILED") {
      message.error(result.data.message);
      return;
    }

    if (result.data.code === "SUCCESS") {
      let date = moment(new Date()).format("YYYYMMDDHHmmssSSS");
      let transactionId = "MT" + date;
      let appointmentDetails =
        transactionId +
        "|" +
        result.data?.responseDetails.patientId +
        "|" +
        appointmentObj.userId +
        "|" +
        result.data?.responseDetails.appointmentId +
        "|" +
        appointmentObj.account_Id +
        "|" +
        appointmentObj.clinic_Id;
      let base64string = Base64.encode(appointmentDetails);
      let paymentPayload = {
        // merchantId: process.env.REACT_APP_PHONEPE_MERCHANT_ID,
        merchantTransactionId: transactionId,
        // merchantUserId: "MUID123",
        amount: parseFloat(result.data.responseDetails?.totalAmount) * 100,
        redirectUrl: `${process.env.REACT_APP_FRONTEND_URL}phonepepayment/${base64string}`,
        redirectMode: "POST",
        callbackUrl: `${process.env.REACT_APP_BASE_URL}/phonePeResponse1/paymentCallBackDetails`,
        mobileNumber: result.data.responseDetails?.mobile,
        paymentInstrument: {
          type: "PAY_PAGE",
        },
      };

      const PHONE_PE_HOST_URL = process.env.REACT_APP_PHONPE_HOST_URL;
      let bufferObj = Buffer.from(JSON.stringify(paymentPayload), "utf8");
      let base64EncodedPayload = bufferObj.toString("base64");
      let string =
        base64EncodedPayload +
        "/pg/v1/pay" +
        process.env.REACT_APP_PHONEPE_SALT_KEY;
      let sha256_val = sha256(string);
      let xVerifyChecksum = sha256_val + "###" + 1;

      let phonepeTransaction = {
        account_Id: appointmentObj.account_Id,
        checksum: xVerifyChecksum,
        clinic_id: appointmentObj.clinic_Id,
        createdBy: result.data.responseDetails?.patientId,
        createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        paidDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
        modifiedBy: result.data.responseDetails?.patientId,
        patientId: result.data.responseDetails?.patientId,
        enoCodePayload: base64EncodedPayload,
        providerreferenceId: "",
        serviceCode: "APPT",
        serviceName: "Appointment Consultation",
        status: 1,
        serviceTransId: result.data?.responseDetails.appointmentId,
        transactionId: transactionId,
        userId: appointmentObj.userId,
        amount: result.data.responseDetails?.totalAmount,
      };

      const res = await PaymentService.PhonepeTransaction(phonepeTransaction);

      if (res.data === 1) {
        let appointmentId = result.data.responseDetails?.appointmentId;

        let billingTransaction = {
          account_Id: appointmentObj.account_Id,
          amount: result.data.responseDetails?.totalAmount,
          clinic_id: appointmentObj.clinic_Id,
          createdBy: result.data.responseDetails?.patientId,
          createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          discountAmount: data?.discountAmount || 0,
          discountPercentage: 0,
          gst: 0,
          modifiedBy: result.data.responseDetails?.patientId,
          modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paidAmount: result.data.responseDetails?.totalAmount,
          patientId: result.data.responseDetails?.patientId,
          paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paymode: "PhonePe",
          serviceCode: "",
          serviceCost: data?.consultationFee || 0,
          serviceName: "",
          serviceTransId: result.data.responseDetails?.appointmentId,
          status: 0,
          transactionId: transactionId,
          userId: appointmentObj.userId,
          billingTransactionServices: [],
        };

        let array1 = {
          account_Id: appointmentObj.account_Id,
          amount: data.consultationFee,
          clinic_id: appointmentObj.clinic_Id,
          createdBy: result.data.responseDetails?.patientId,
          createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          fromDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          modifiedBy: result.data.responseDetails?.patientId,
          modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paidAmount: result.data.responseDetails?.totalAmount,
          patientId: result.data.responseDetails?.patientId,
          paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          paymode: "PhonePe",
          serviceCode: "APPT",
          serviceCost: data.consultationFee,
          serviceName: "Appointment Consultation",
          serviceTransId: result.data.responseDetails?.appointmentId,
          status: 0,
          toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
          transactionId: transactionId,
          userId: appointmentObj.userId,
        };

        billingTransaction.billingTransactionServices.push(array1);

        if (data.patientRegFeeYN === "Y") {
          billingTransaction.billingTransactionServices = [
            {
              account_Id: appointmentObj.account_Id,
              amount: data.patientRegFee,
              clinic_id: appointmentObj.clinic_Id,
              createdBy: result.data.responseDetails?.patientId,
              createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              fromDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              modifiedBy: result.data.responseDetails?.patientId,
              modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              paidAmount: data.patientRegFee,
              patientId: result.data.responseDetails?.patientId,
              paymentDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              paymode: "PhonePe",
              serviceCode: "REG_FEE",
              serviceCost: data.patientRegFee,
              serviceName: "Patient Registration Fee",
              serviceTransId: result.data.responseDetails?.appointmentId,
              status: 0,
              toDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
              transactionId: transactionId,
              userId: appointmentObj.userId,
            },
          ];
        }

        const billingRes = await PaymentService.BillingTransaction(
          billingTransaction
        );

        if (billingRes.data === 1) {
          const configurationObject = {
            method: "POST",
            url: PHONE_PE_HOST_URL,
            data: { request: base64EncodedPayload },
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "X-VERIFY": xVerifyChecksum,
            },
          };

          const response = await PaymentService.initiatePayment(
            configurationObject.data
          );
          window.location.replace(response.data.PhonePeURL);
        }
      }
    }
  } catch (error) {
    console.error("An error occurred:", error);
    message.error("An error occurred while sending invite. Please try again.");
  }
};
